import Vue from 'vue'
import Router from 'vue-router'
import yybIndex from './views/market/yybIndex.vue'
import index from './views/market/index.vue'
import fzIndex from './views/market/fzIndex.vue'
import aboutUsIndex from './views/market/aboutUsIndex.vue'
import helpIndex from './views/market/helpIndex.vue'
import helpDetail from './views/market/helpDetail.vue'
import service from './views/market/service.vue'
import privates from './views/market/private.vue'
import wkzqprivate from './views/market/privateWkApp.vue'

import mzQqbApp from './views/market/mzQqbApp.vue'
import privateQqbApp from './views/market/privateQqbApp.vue'
import contractIndex from './views/contract/contractIndex.vue'
import commonprivate from './views/market/privateCommon.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: "/marketapp/",
  routes: [
    {
      path: '/fzIndex/:type',
      name: 'fzIndex',
      component: fzIndex,
      meta: { title: "" }
    },{
      path: '/index/:type',
      name: 'index',
      component: index,
      meta: { title: "" }
    }, {
      path: '/yybIndex',
      name: 'yybIndex',
      component: yybIndex,
      meta: { title: "营业部网点" }
    }, {
      path: '/aboutUsIndex',
      name: 'aboutUsIndex',
      component: aboutUsIndex,
      meta: { title: "关于我们" }
    }, {
      path: '/helpIndex',
      name: 'helpIndex',
      component: helpIndex,
      meta: { title: "帮助中心" }
    }, {
      path: '/helpDetail/:id?',
      name: 'helpDetail',
      component: helpDetail,
      meta: { title: "帮助中心详情" }
    }, {
      path: '/private',
      name: 'private',
      component: privates,
      meta: { title: "隐私保护条款" }
    }, {
      path: '/wkzqprivate',
      name: 'wkzqprivate',
      component: wkzqprivate,
      meta: { title: "隐私保护条款" }
    },{
      path: '/service',
      name: 'service',
      component: service,
      meta: { title: "服务协议" }
    }, {
      path: '/mzQqbApp',
      name: 'mzQqbApp',
      component: mzQqbApp,
      meta: { title: "免责协议" }
    },{
      path: '/privateQqbApp',
      name: 'privateQqbApp',
      component: privateQqbApp,
      meta: { title: "隐私保护条款" }
    },{
      path: '/privateCo/:contractId',
      name: 'commonprivate',
      component: commonprivate,
      meta: { title: "隐私保护条款" }
    },{
      path: '/contractIndex/:contractId',
      name: 'contractIndex',
      component: contractIndex,
      meta: { title: "五矿证券" }
    },
  ]
})
